/**
 * 画像作成指示画面返却用VO
 *
 * @export KYMW0C00OutputModel
 * @class KYMW0C00OutputModel
 */
export class KYMW0C00OutputModel {
  // 受注コード
  public OrderCode = '';

  // リスト
  public ImageList: ImageInfo[] = [];
}

export class ImageInfo {
  // 生協コード
  public CoopCode = ''

  // 画像ID
  public ImageId = ''

  // 画像パスID
  public ImagePathId = ''

  // 表示順
  public ShowSeq = ''

  // 画像表示用キャプション
  public TextCaption = ''
}
